<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!--       搜索-->
      <div>
        <el-input
          style="width: 180px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="queryParams.condition.keyWord"
          size="small"
          @keydown.enter.native="initCost"
          @clear="initCost"
          placeholder="请输入信息进行搜索..."
          clearable
        >
        </el-input>
        <el-radio v-model="queryParams.condition.expired" label=""
          >所有</el-radio
        >
        <el-radio v-model="queryParams.condition.expired" label="0"
          >未过期</el-radio
        >
        <el-radio v-model="queryParams.condition.expired" label="1"
          >已过期</el-radio
        >
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="initCost"
          size="small"
          >搜索</el-button
        >
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-if="qx"
          @click="showAddView"
          >上传证书</el-button
        >
        <el-button
          type="success"
          style="margin-left: 10px"
          size="small"
          @click="exportSelectedData"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出选中数据
        </el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="costData"
        class="el-table"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
        size="small"
        :row-style="{ height: '62px' }"
        height="calc(100vh - 250px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
        :default-sort="{ prop: 'controlGrade', order: 'descending' }"
        :row-class-name="tableRowClassName"
      >
        <!-- 多选框-->
        <el-table-column
          type="selection"
          align="center"
          width="55"
          fixed="left"
        >
        </el-table-column>

        <el-table-column prop="proveBook" label="证书中文名称" align="center">
        </el-table-column>

        <el-table-column
          prop="validDate"
          label="证书到期时间"
          align="center"
          min-width="130"
          :cell-class-name="expiredCellClassName"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
          <template slot-scope="scope">
            {{ scope.row.validDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop="categoryName"
          label="证书类别"
          align="center"
          min-width="50"
        >
        </el-table-column>
        <el-table-column
          prop="sendProveUnitName"
          label="发证机关"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="inCompany"
          label="证书是否在公司"
          align="center"
          min-width="50"
        >
          <template slot-scope="scope">
            <div>
              <el-tag
                v-if="scope.row.inCompany === true"
                type="success"
                size="mini"
                >是</el-tag
              >
              <el-tag
                v-else-if="scope.row.inCompany === false"
                type="danger"
                size="mini"
                >否</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="isForever"
          label="证书是否永久"
          align="center"
          min-width="50"
        >
          <template slot-scope="scope">
            <div>
              <el-tag
                v-if="scope.row.isForever === true"
                type="success"
                size="mini"
                >是</el-tag
              >
              <el-tag
                v-else-if="scope.row.isForever === false"
                type="danger"
                size="mini"
                >否</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="haveSource"
          label="是否有原件"
          align="center"
          min-width="50"
        >
          <template slot-scope="scope">
            <div>
              <el-tag
                v-if="scope.row.haveSource === true"
                type="success"
                size="mini"
                >是</el-tag
              >
              <el-tag
                v-else-if="scope.row.haveSource === false"
                type="danger"
                size="mini"
                >否</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述信息"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="230">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              v-if="qx"
              >编辑</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="showDetail(scope.row)"
              v-if="qx"
              >详情</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              v-if="qx"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 5px;
        "
      >
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="queryParams.page">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="编辑证书"
      :visible.sync="editDialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form
        :model="inputobjCerti"
        :rules="rules"
        ref="inputobjCerti"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="证书名称" prop="proveBook">
              <el-input
                v-model="inputobjCerti.proveBook"
                placeholder="请输入证书名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书类别" prop="category">
              <el-select v-model="inputobjCerti.category" placeholder="请选择">
                <el-option
                  v-for="item in typeSelect"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证书缩写" prop="brief">
              <el-input
                v-model="inputobjCerti.brief"
                placeholder="请输入证书缩写"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发证机关" prop="sendProveUnit">
              <!-- <el-input
                v-model="inputobjCerti.sendProveUnit"
                placeholder="请输入发证机关"
              ></el-input> -->
              <el-select
                v-model="inputobjCerti.sendProveUnit"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in unitSelect"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="证书到期时间"
              prop="validDate"
              label-width="120px"
            >
              <el-date-picker
                v-model="inputobjCerti.validDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否有原件"
              prop="haveSource"
              label-width="115px"
            >
              <el-radio-group v-model="inputobjCerti.haveSource">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="证书是否在公司"
              prop="inCompany"
              label-width="140px"
            >
              <el-radio-group v-model="inputobjCerti.inCompany">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="证书是否永久"
              prop="isForever"
              label-width="130px"
            >
              <el-radio-group v-model="inputobjCerti.isForever">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述信息" prop="description">
          <el-input
            v-model="inputobjCerti.description"
            placeholder="请输入描述信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书图片" prop="certiImg">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeAvatarUpload"
            :file-list="[]"
            multiple
            name="file"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5MB
            </div>
          </el-upload>
          <!-- 新增附件列表展示区域 -->
          <div v-if="fileList.length > 0" style="margin-top: 10px">
            <h4>已上传附件列表</h4>
            <el-table :data="fileList" style="width: 100%" border stripe>
              <el-table-column prop="name" label="文件名" align="center">
              </el-table-column>
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.uploading">上传中...</span>
                  <span v-else-if="scope.row.error">上传失败</span>
                  <span v-else>已上传</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <!-- <el-button
                    size="mini"
                    type="primary"
                    @click="downloadFile(scope.row)"
                    style="margin-right: 5px"
                    :disabled="scope.row.uploading || scope.row.error"
                  >
                    下载
                  </el-button> -->
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteFile(scope.row)"
                    style="margin-right: 5px"
                    :disabled="scope.row.uploading"
                  >
                    删除
                  </el-button>
                  <!-- <el-button
                    size="mini"
                    type="info"
                    @click="viewFile(scope.row)"
                    :disabled="scope.row.uploading || scope.row.error"
                  >
                    查看
                  </el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCerti">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="证书详情"
      :visible.sync="detailDialogVisible"
      width="35%"
      class="certificate-detail-dialog"
    >
      <div class="dialog-content">
        <div class="certificate-info">
          <!-- 证书信息样式优化 -->
          <p class="info-item">
            <strong class="info-label">证书中文名称：</strong>
            <span class="info-value">{{ detailData.proveBook }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">证书到期时间：</strong>
            <span class="info-value">{{ detailData.validDate }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">证书类别：</strong>
            <span class="info-value">{{ matchType(detailData.category) }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">发证机关：</strong>
            <span class="info-value">{{ matchUnit(detailData.sendProveUnit) }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">证书是否在公司：</strong>
            <span class="info-value">{{
              detailData.inCompany ? "是" : "否"
            }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">证书是否永久：</strong>
            <span class="info-value">{{
              detailData.isForever ? "是" : "否"
            }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">是否有原件：</strong>
            <span class="info-value">{{
              detailData.haveSource ? "是" : "否"
            }}</span>
          </p>
          <p class="info-item">
            <strong class="info-label">描述信息：</strong>
            <span class="info-value">{{ detailData.description }}</span>
          </p>
        </div>
        <div class="attachment-list">
          <h4>附件列表</h4>
          <el-table
            :data="detailData.fileList || []"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column
              prop="name"
              label="文件名"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="viewFile(scope.row)"
                  style="margin-right: 5px"
                  :disabled="scope.row.uploading || scope.row.error"
                >
                  查看
                </el-button>
                <el-button
                  size="mini"
                  type="success"
                  @click="downloadFile(scope.row)"
                  style="margin-right: 5px"
                  :disabled="scope.row.uploading || scope.row.error"
                >
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="previewVisible"
      title="文件预览"
      width="50%"
      top="5vh"
      class="preview-dialog"
      @closed="handlePreviewClose"
    >
      <div style="height: 70vh; overflow: auto">
        <iframe
          v-if="previewImageUrl && previewImageUrl.endsWith('.pdf')"
          :src="`https://docs.google.com/gview?url=${encodeURIComponent(
            previewImageUrl
          )}&embedded=true`"
          style="width: 100%; height: 100%"
          frameborder="0"
        ></iframe>
        <img
          v-else
          class="preview-image"
          :src="previewImageUrl"
          style="width: 600px; display: block; margin: 0 auto"
        />
      </div>
    </el-dialog>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import table2excel from "js-table2excel/src";

import {
  getQualifyProveList,
  postQualifyProve,
  deleteQualifyProve,
  downloadQualifyProve,
} from "@/api/certi/CertiQualifyProve";
export default {
  data() {
    return {
      previewVisible: false,
      previewImageUrl: "",
      loading: false,
      headers: {
        userIdStr: sessionStorage.getItem("userIdStr"),
      },
      uploadUrl: this.$store.state.IPAss.TP + "/work/file-manage/upload",
      costData: [],
      detailData: {},
      total: 0,
      fileList: [], // 存储已上传的文件列表
      typeSelect: [], //证书类型
      unitSelect: [], //发证单位
      queryParams: {
        condition: {
          keyWord: "",
          expired: "", // 0: 未过期, 1: 已过期, 2: 所有
        },
        limit: 10,
        page: 1,
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
      detailDialogVisible: false,
      qx: true,
      inputobjCerti: {
        id: "",
        proveBook: "",
        category: "",
        validDate: "",
        sendProveUnit: "",
        description: "",
        haveSource: true,
        isForever: true,
        inCompany: true,
        fileIds: [],
      },
      editDialogVisible: false,
      rules: {
        proveBook: [
          { required: true, message: "请输入证书名称", trigger: "blur" },
        ],
        inCompany: [
          { required: true, message: "请选择证书是否在公司", trigger: "blur" },
        ],
        isForever: [
          { required: true, message: "请选择证书是否永久", trigger: "blur" },
        ],
        brief: [{ required: true, message: "请输入证书缩写", trigger: "blur" }],
        haveSource: [
          { required: true, message: "请选择是否有原件", trigger: "blur" },
        ],
        category: [
          { required: true, message: "请输入证书类别", trigger: "blur" },
        ],
        validDate: [
          { required: true, message: "请选择证书到期时间", trigger: "blur" },
        ],
        sendProveUnit: [
          { required: true, message: "请输入发证机关", trigger: "blur" },
        ],
      },
      companyList: [],
      Type1: [],
      Units: [],
      selectedRows: [],
    };
  },
  created() {
    this.getQualifyProveList();
    // this.quanxian();
    this.getType();
  },
  methods: {
    //匹配证书类别
    matchType(type) {
      for (let i = 0; i < this.typeSelect.length; i++) {
        if (this.typeSelect[i].code === type) {
          return this.typeSelect[i].name;
        }
      }
      return type;
    },
    //匹配发证单位
    matchUnit(unit) {
      for (let i = 0; i < this.unitSelect.length; i++) {
        if (this.unitSelect[i].code === unit) {
          return this.unitSelect[i].name;
        }
      }
      return unit;
    },

    //判断是否有权限
    quanxian() {
      if (this.doesItContain([1, 32])) {
        this.qx = false;
      } else {
        this.qx = true;
      }
    },
    //获取证书类型
    getType() {
      this.postRequest(
        `/dim/get_two_level_dim_table_char?type=qualify_prove_type`
      )
        .then((resp) => {
          if (resp.code === 200) {
            this.typeSelect = resp.result;
          } else {
            this.$message.error(resp.msg);
          }
        })
        .catch((error) => {
          console.error("获取证书类型选项失败：", error);
        });
      this.postRequest(`/dim/get_two_level_dim_table_char?type=company`)
        .then((resp) => {
          if (resp.code === 200) {
            this.unitSelect = resp.result;
          } else {
            this.$message.error(resp.msg);
          }
        })
        .catch((error) => {
          console.error("获取发证单位失败：", error);
        });
    },
    // 表格行样式
    tableRowClassName({ row }) {
      if (!row.validDate) return "";

      const today = new Date();
      const expireDate = new Date(row.validDate);
      const timeDiff = expireDate.getTime() - today.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

      // 已过期 - 红色背景
      if (daysDiff < 0) {
        return "expired-row";
      }
      // 30天内到期 - 橙色背景
      else if (daysDiff <= 30) {
        return "expiring-row";
      }
      return "";
    },

    // 过期单元格样式
    expiredCellClassName({ row, column }) {
      if (column.property === "validDate" && row.validDate) {
        const today = new Date();
        const expireDate = new Date(row.validDate);
        const timeDiff = expireDate.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        // 已过期 - 深红色背景
        if (daysDiff < 0) {
          return "expired-cell";
        }
        // 30天内到期 - 橙色背景
        else if (daysDiff <= 30) {
          return "expiring-cell";
        }
      }
      return "";
    },
    // 获取证书列表
    getQualifyProveList() {
      this.loading = true;
      getQualifyProveList(this.queryParams).then((res) => {
        this.loading = false;
        this.costData = res.data.records;
        this.total = res.data.total;
      });
    },
    //详情
    showDetail(row) {
      this.detailData = row;
      this.detailData.fileList = row.fileIdStr
        ? row.fileIdStr.split(",").map((id, index) => {
            const fileName = row.fileNameStr.split(",")[index];
            return {
              name: fileName,
              url: row.fileUrlStr.split(",")[index],
              id: id,
            };
          })
        : [];

      this.detailDialogVisible = true;
    },
    //

    // 编辑证书
    showEditView(row) {
      // 打开编辑对话框
      this.editDialogVisible = true;

      // 定义需要回显的字段
      const fields = [
        "id",
        "proveBook",
        "category",
        "validDate",
        "sendProveUnit",
        "description",
        "haveSource",
        "isForever",
        "inCompany",
        "brief",
      ];

      // 回显表单数据
      this.inputobjCerti = fields.reduce(
        (obj, field) => {
          obj[field] = row[field];
          return obj;
        },
        { fileIds: row.fileIdStr ? row.fileIdStr.split(",") : [] }
      );

      // 回显附件
      if (row.fileIdStr) {
        const fileIds = row.fileIdStr.split(",");
        const fileNames = row.fileNameStr.split(",");
        const fileUrls = row.fileUrlStr.split(",");
        this.fileList = fileIds.map((id, index) => ({
          name: fileNames[index],
          url: fileUrls[index],
          id,
        }));
      } else {
        this.fileList = [];
      }
    },
    showAddView() {
      this.editDialogVisible = true;
    },
    // 搜索
    search() {
      this.pageNum = 1;
      this.pageSize = 200;
      this.getQualifyProveList();
    },
    kaiguan(createTime) {
      let now = new Date();
      let create = new Date(createTime);
      if (now.getTime() - create.getTime() > 24 * 60 * 60 * 1000) {
        return true;
      } else {
        return false;
      }
    },
    //提交内容
    submitCerti() {
      // 判断是新增还是编辑操作
      const isEdit = this.inputobjCerti.id;
      // const apiMethod = isEdit ? putQualifyProve : postQualifyProve;

      postQualifyProve(this.inputobjCerti)
        .then((res) => {
          this.$message({
            message: isEdit ? "编辑成功" : "新增成功",
            type: "success",
          });
          this.editDialogVisible = false;
          this.getQualifyProveList();
        })
        .catch((error) => {
          this.$message({
            message: isEdit ? "编辑失败" : "新增失败",
            type: "error",
          });
          console.error(error);
        });
    },
    // 下载证书
    downloadCertificate(row) {
      let url = row.certificateUrl;
      window.open(url, "_blank");
    },
    // 删除证书
    deleteRecord(row) {
      this.$confirm("是否删除该证书？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteQualifyProve(row.id).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getQualifyProveList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    initCost() {
      this.queryParams.page = 1; // 原来重置的是 pageNum，而请求/翻页用的是 page
      this.getQualifyProveList();
    },
    //选择
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 <= 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false; // 阻止不符合类型的文件上传
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false; // 阻止超过大小限制的文件上传
      }
      return true; // 允许符合要求的文件上传
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success("上传成功");
        this.inputobjCerti.fileIds.push(res.data.id);
      } else {
        this.$message.error("上传失败");
      }
    },
    viewFile(file) {
      if (file.url) {
        const fileUrl = this.$store.state.IPAss.TP + file.url;
        this.previewImageUrl = fileUrl;
        this.previewVisible = true;

        // 添加水印
        this.$nextTick(() => {
          this.addWatermark();
        });
      } else {
        this.$message.error("文件 URL 不存在");
      }
    },
    // 水印方法
    addWatermark() {
      const createPattern = (text, options = {}) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 密度参数配置
        const config = {
          fontSize: 24,
          rotate: -15,
          opacity: 0.15,
          colSpace: 200, // 列间距
          rowSpace: 80, // 行间距
          ...options,
        };

        canvas.width = config.colSpace * 1;
        canvas.height = config.rowSpace * 1;

        ctx.font = `${config.fontSize}px Arial`;
        ctx.fillStyle = `rgba(0,0,0,${config.opacity})`;
        ctx.textAlign = "center";
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((config.rotate * Math.PI) / 180);

        // 生成矩阵平铺
        for (
          let x = -canvas.width;
          x < canvas.width * 2;
          x += config.colSpace
        ) {
          for (
            let y = -canvas.height;
            y < canvas.height * 2;
            y += config.rowSpace
          ) {
            ctx.fillText(text, x, y);
          }
        }
        return canvas.toDataURL();
      };

      const container = document.querySelector(
        ".preview-dialog .el-dialog__body"
      );
      if (!container) return;

      // 创建平铺水印层
      const watermarkLayer = document.createElement("div");
      Object.assign(watermarkLayer.style, {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: "9999",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        background: `url(${createPattern("仅限展示预览使用", {
          fontSize: 20,
        })}) repeat`,
      });

      container.appendChild(watermarkLayer);
    },
    // 关闭预览回调
    handlePreviewClose() {
      const watermark = document.querySelector(
        '[style*="pointer-events: none"]'
      );
      if (watermark) {
        watermark.remove();
      }
    },
    // 处理文件上传成功事件
    handleUploadSuccess(response, file, fileList) {
      this.$message.success("上传成功");
      // 将上传成功的文件添加到 fileList 中
      this.fileList = fileList;
      // 将文件 ID 添加到 inputobjCerti 的 fileIds 中
      this.inputobjCerti.fileIds.push(response.data.id);
    },
    //下载附件
    downloadFile(file) {
      if (file.url) {
        downloadQualifyProve(file.id).then((res) => {
          console.log(res, "下载结果");
          const blob = new Blob([res], { type: "application/octet-stream" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = file.name; // 设置下载文件的名称
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url); // 释放 URL 对象
          document.body.removeChild(a); // 移除链接元素
        });
      }
    },
    // 处理文件上传失败事件
    handleUploadError(err, file, fileList) {
      this.$message.error("上传失败");
      // 找到上传失败的文件并标记错误状态
      const index = fileList.indexOf(file);
      if (index !== -1) {
        this.fileList[index].uploading = false;
        this.fileList[index].error = true;
      }
    },
    // 删除附件
    deleteFile(file) {
      this.$confirm("是否删除该附件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 从 fileList 中移除该文件
          const index = this.fileList.findIndex((item) => item.id === file.id);
          if (index !== -1) {
            this.fileList.splice(index, 1);
          }
          // 从 inputobjCerti.fileIds 中移除对应的文件 ID
          const idIndex = this.inputobjCerti.fileIds.indexOf(file.id);
          if (idIndex !== -1) {
            this.inputobjCerti.fileIds.splice(idIndex, 1);
          }
          this.$message.success("附件删除成功");
        })
        .catch(() => {
          // 用户取消删除操作
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleDetailClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.detailDialogVisible = false;
          done();
        })
        .catch((_) => {});
    },
    //分页
    currentChange(val) {
      this.queryParams.page = val;
      this.getQualifyProveList();
    },
    sizeChange(val) {
      this.queryParams.page = 1; // 改每页条数：回到第 1 页
      this.queryParams.limit = val;
      this.getQualifyProveList();
    },
    // 提取列标题映射逻辑到单独的方法
    getColumnTitle(key) {
      const mapping = {
        proveBook: "证书中文名称",
        validDate: "证书到期时间",
        category: "证书类别",
        sendProveUnit: "发证机关",
        inCompany: "证书是否在公司",
        isForever: "证书是否永久",
        haveSource: "是否有原件",
        description: "描述",
      };
      return mapping[key];
    },

    //导出选中数据
    async exportSelectedData() {
      const columns = [
        "proveBook",
        "validDate",
        "category",
        "sendProveUnit",
        "inCompany",
        "isForever",
        "haveSource",
        "description",
      ];
      const columnConfig = columns.map((key) => ({
        title: this.getColumnTitle(key),
        key,
        type: "text",
        width: 100,
        height: 100,
      }));
      const rowsToExport = this.costData
        .filter((row, index) => this.selectedRows[index])

        .map((ele) => ({
          ...ele,
          category: this.matchType(ele.category),
          isForever: ele.isForever === "1" ? "是" : "否",
          inCompany: ele.inCompany === "1" ? "是" : "否",
          haveSource: ele.haveSource === "1" ? "是" : "否",
        }));
      const excelName = "证书列表";
      table2excel(columnConfig, rowsToExport, excelName);
    },
  },
};
</script>

<style>
/* 已过期行样式 */
.el-table .expired-row {
  background-color: #facccc;
}

/* 30天内到期行样式 */
.el-table .expiring-row {
  background-color: #fff8e6;
}

/* 已过期单元格样式 */
.el-table .expired-cell {
  background-color: #ffebee !important;
  color: #f56c6c;
  font-weight: bold;
}

/* 30天内到期单元格样式 */
.el-table .expiring-cell {
  background-color: #fff3e0 !important;
  color: #ff9800;
  font-weight: bold;
}

/* 其他已有样式保持不变... */

.aligned-rate {
  margin-top: 5px; /* 调整这个值以控制下移的距离 */
}
.certificate-radio-group {
  margin-top: 5px;
}
.el-table .warn {
  background-color: #f3de25ff;
}
.el-table .expireds {
  background-color: #f7b7bcff !important;
}

.certificate-info {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.info-label {
  width: 150px;
  font-weight: bold;
  color: #333;
}

.info-value {
  color: #666;
}
</style>


